export default "https://assets.egbcdn.net/assets/packs/_/images/gamer-logo-c7bf15c5cbceacc7205b7bad3061a442.svg";